import config from "../config.json";
import { apiClient, getAccessToken } from "./apiClient";

const ReportRequests = async (queryParams) => {
    const token = await getAccessToken();
    queryParams = queryParams || {};
    const params = new URLSearchParams();
    let paramCount = 0;

    Object.entries(queryParams).forEach(([key, value]) => {
        if (value != null && value !== undefined) {
            params.append(key, value);
            paramCount++;
        }
    });

    let url = `${config.API_URL}/reports/requests`;

    if (paramCount > 0) {
        url += `?${params.toString()}`;
    }

    let headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
    };

    try {
        return await apiClient.get(url, {
            headers,
            responseType: "blob",
            timeout: config.API_CONNECTION_TIMEOUT,
        });
    } catch (error) {
        throw error;
    }
};

/**
 * GetDashboard
 * ยิง GET /reports/dashboard พร้อม query params: year, month, id_business_unit (optional)
 * Response เป็น JSON ปกติ (ไม่ใช่ blob) - โครงสร้างดู mapDashboardResponse.js ประกอบ
 */
const GetDashboard = async (queryParams) => {
    const token = await getAccessToken();
    queryParams = queryParams || {};
    const params = new URLSearchParams();

    Object.entries(queryParams).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== "") {
            params.append(key, value);
        }
    });

    let url = `${config.API_URL}/reports/dashboard`;
    if (params.toString()) {
        url += `?${params.toString()}`;
    }

    const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
    };

    try {
        return await apiClient.get(url, {
            headers,
            timeout: config.API_CONNECTION_TIMEOUT,
        });
    } catch (error) {
        throw error;
    }
};

/**
 * ExportMessengerReport
 * ยิง GET /reports/messengers คืนไฟล์ .xlsx (Summary + Coverage)
 * @param {{ service_date_start?: string, service_date_end?: string, id_messenger?: number }} queryParams
 */
const ExportMessengerReport = async (queryParams) => {
    const token = await getAccessToken();
    queryParams = queryParams || {};
    const params = new URLSearchParams();

    Object.entries(queryParams).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
            params.append(key, value);
        }
    });

    let url = `${config.API_URL}/reports/messengers`;
    if (params.toString()) {
        url += `?${params.toString()}`;
    }

    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${token}`,
    };

    try {
        return await apiClient.get(url, {
            headers,
            responseType: 'blob',
            timeout: config.API_CONNECTION_TIMEOUT,
        });
    } catch (error) {
        throw error;
    }
};

const ReportsService = {
    ReportRequests,
    GetDashboard,
    ExportMessengerReport,
};

export default ReportsService;